import { ModalOrNotificationList } from "./ModalOrNotificationList";

export class NotificationList
{
	static open()
	{
		ModalOrNotificationList.open()
		const body = document.querySelectorAll('.o-body')[0];
		body.classList.add('o-body--withOpenNotifications');
	}

	static close()
	{
		const body = document.querySelectorAll('.o-body')[0];
		body.classList.remove('o-body--withOpenNotifications');
		ModalOrNotificationList.close()
	}
}
